module.exports = __webpack_public_path__ + "static/media/eurastech-logo_new.ec72b2df.jpg";